<template>
  <a-space>
    <img  height="64" src="../../assets/images/logo.png">
    <!-- <span v-if="!iconOnly" style="font-weight: 500; user-select: none; color: black; font-size: 28px">
      河北省住房和城乡建设厅
    </span> -->
  </a-space>
</template>

<script>
export default {
  name: 'LogoIcon',
  props: {
    iconOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      component: {
        template: `
          <svg viewBox="0 0 128 128" width="128" height="128">
            <path d="M64 0C99.3462 0 128 28.6538 128 64C128 99.3462 99.3462 128 64 128C28.6538 128 0 99.3462 0 64C0 28.6538 28.6538 0 64 0ZM64.0028 26.3529C48.4397 26.3529 30.8711 38.902 11.2969 64C20.5265 75.8343 29.3103 84.8785 37.6481 91.1326L37.6471 64L37.6623 63.094C38.1399 48.9592 49.7489 37.6471 64 37.6471C78.5543 37.6471 90.3529 49.4457 90.3529 64C90.3529 78.5543 78.5543 90.3529 64 90.3529C57.5491 90.3529 51.6396 88.0351 47.0589 84.1868L47.0615 97.1059C52.9505 100.133 58.5976 101.647 64.0028 101.647C79.5659 101.647 97.1345 89.098 116.709 64C97.1345 38.902 79.5659 26.3529 64.0028 26.3529ZM64 47.0588C54.6436 47.0588 47.0588 54.6436 47.0588 64C47.0588 73.3564 54.6436 80.9412 64 80.9412C73.3564 80.9412 80.9412 73.3564 80.9412 64C80.9412 54.6436 73.3564 47.0588 64 47.0588ZM60.2353 60.2353V75.2941C56.0769 75.2941 52.7059 71.9231 52.7059 67.7647C52.7059 63.6063 56.0769 60.2353 60.2353 60.2353ZM67.7647 52.7059C71.9231 52.7059 75.2941 56.0769 75.2941 60.2353C75.2941 64.3937 71.9231 67.7647 67.7647 67.7647V52.7059Z" fill="currentColor"></path>
          </svg>
        `
      }
    }
  }
}
</script>
